export const HOMEPAGE_HERO_SPLIT = 'HomepageHeroSplit'
export const DEFAULT_HOME = 'DefaultHome'
